/**
 * Admin-API: Sales-Browser-Anrufe (Twilio Voice JS SDK)
 * Holt einen kurzlebigen AccessToken fuer das Device im Browser.
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function fetchVoiceToken({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/voice/token`, {
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Voice-Token konnte nicht geladen werden");
  return { token: j.token, identity: j.identity };
}
